import { createAction } from 'typesafe-actions';

// intermittent background poll to keep the ui relatively fresh
export const pollBackgroundNotificationsUpdateState = createAction(
  'POLL/BACKGROUND_NOTIFICATIONS_UPDATE_STATE',
  (resolve) => {
    return (payload: { user_id: number | null }) => resolve(payload);
  }
);
